@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (pageReady && AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div>
      <div class="text-900 font-medium text-xl mb-3"><h3>Product Options for: {{ productName }}</h3></div>
      <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        Select which options are available for this product. Options marked as Available will be presented to staff when this product is added to a sale.
      </p>
      <div class="surface-card p-4 shadow-2 border-round">
        <p-table [value]="optionRows" sortField="option.name" responsiveLayout="scroll">
          <ng-template #header>
            <tr>
              <th pSortableColumn="option.name" width="45%">Option Name</th>
              <th pSortableColumn="option.price" width="20%">Price</th>
              <th width="35%">Availability</th>
            </tr>
          </ng-template>
          <ng-template #body let-row>
            <tr [ngStyle]="{'background-color': row.selected ? '#f0fdf4' : '#ffffff'}">
              <td style="font-weight: 500;">{{ row.option.name }}</td>
              <td>{{ row.option.price | currency:CurrencySymbol }}</td>
              <td>
                <p-selectbutton
                  [options]="availabilityOptions"
                  [(ngModel)]="row.selected"
                  optionLabel="label"
                  optionValue="value"
                  styleClass="nowrap-select-btn">
                </p-selectbutton>
              </td>
            </tr>
          </ng-template>
          <ng-template #emptymessage>
            <tr>
              <td colspan="3" style="text-align:center; padding: 40px; color: #9ca3af;">
                No global product options exist yet.
                <a [routerLink]="['/tillproductoptions']" style="color:#3b82f6; text-decoration:underline; cursor:pointer;">Add some options first.</a>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <div style="margin-top: 20px;">
          <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="saveAssignments()">
            <span class="pi pi-check" style="margin-right:8px;"></span>Save
          </button>
          &nbsp;
          <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="cancel()">
            <span class="pi pi-times" style="margin-right:8px;"></span>Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
}
